import React from "react";
import { Routes, Route } from "react-router";

import useAppContext from "../../hooks/useAppContext";
import ContentWrapper from "../../components/admin/contentWrapper/contentWrapper.component";
import LeftNavigationWrapper from "../../components/admin/leftNavigationWrapper/leftNavigationWrapper.component";
import PageWrapper from "../../components/admin/pageWrapper/pageWrapper.component";

import DashboardLayout from "../../components/admin/dashboardLayout/dashboardLayout.component";
import DemographicsLayout from "../../components/admin/demographicsLayout/demographicsLayout.component";
import OpportunityLayout from "../../components/admin/opportunityLayout/opportunityLayout.component";
import TableLayout from "../../components/admin/tableLayout/tableLayout.component";
import CompanyNewPage from "../../components/admin/company/new/newPage/newPage.component";
import InvoiceNewPage from "../../components/admin/company/invoice/newPage/newPage.component";
import ChallengerSupportTools from "../../components/admin/company/supportTools/page/page.component";
import StudentSupportTools from "../../components/admin/student/supportTools/page/page.component";
import ChallengeNewPage from "../../components/admin/contest/new/page.component";
import ChallengeEditPage from "../../components/admin/contest/edit/page.component";
import ChallengeClonePage from "../../components/admin/contest/clone/page.component";

const components = [
  {
    path: '/',
    element: <DashboardLayout />
  },
  {
    path: '/contests',
    subpages: [
      {
        path: 'drafts',
        element: <TableLayout heading="Challenge Drafts" name="challengeDrafts" />
      },
      {
        path: 'statistics',
        element: <TableLayout heading="Challenge Statistics" name="challengeStatistics" />
      },
      {
        path: 'new',
        element: <ChallengeNewPage />
      },
      {
        path: ':slug/edit',
        element: <ChallengeEditPage />
      },
      {
        path: ':slug/clone',
        element: <ChallengeClonePage />
      },
    ]
  },
  {
    path: '/companies',
    subpages: [
      {
        path: 'new',
        element: <CompanyNewPage />
      },
      {
        path: 'invoices',
        element: <InvoiceNewPage />
      },
      {
        path: 'support_tools',
        element: <ChallengerSupportTools />
      },
    ]
  },
  {
    path: '/students',
    subpages: [
      {
        path: 'demographics',
        element: <DemographicsLayout />
      },
      {
        path: 'support_tools',
        element: <StudentSupportTools />
      }
    ]
  },
  {
    path: '/sales',
    subpages: [
      {
        path: 'challenges',
        element: <TableLayout heading="Challenge Search" name="salesChallenges" />
      },
      {
        path: 'opportunities',
        element: <TableLayout heading="Opportunities" name="salesOpportunities" />
      },
      {
        path: 'opportunity/:id',
        element: <OpportunityLayout />
      }
    ]
  }
]

const AdminRoutes = () => {
  const { railsContext: { adminNavigationMenu: { nav_menu } } } = useAppContext();

  return (
    <PageWrapper>
      <LeftNavigationWrapper>
        <ContentWrapper>
          <Routes>
            {nav_menu.map((item) => {
              const component = components.find(obj => obj.path === item.path)
              if (!component) return null;
              const { children } = item;
              return (
                <Route key={component.path} path={item.path} element={component.element}>
                  {children && children.map(subItem => {
                    const subComponent = component.subpages?.find(obj => obj.path === subItem.path);
                    if (!subComponent) return null;

                    return <Route key={`${item.path}/${subItem.path}`} path={subComponent.path} element={subComponent.element} />
                  })}
                </Route>
              )
            })}
            <Route path="*" Component={() => {
              if (typeof window !== 'undefined') window.location.href = '/404';
              return null;
            }} />
          </Routes>
        </ContentWrapper>
      </LeftNavigationWrapper>
    </PageWrapper>
  );
}

export default AdminRoutes;